export default __webpack_public_path__ + "images/edd3f12c06f511726672ee32f60687ca.svg";